import React from 'react';
import { makeStyles } from '@material-ui/core';
import { ImagineLinkify } from '../TextLinkify';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  content: {
    padding: theme.spacing(4),
  },
  title: {
    fontSize: 20,
    color: theme.palette.neutrals.low.main,
    fontWeight: 'bold',
  },
  infoContainer: {
    padding: theme.spacing(3, 0),
  },
  label: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.neutrals.low.medium,
  },
  description: {
    whiteSpace: 'pre-line',
  },
}));

function ChallengeInfoDetails({ challenge }) {
  const { name, description, goal, requirement } = challenge;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.content}>
      <div className={classes.title}>{name}</div>
      <div className={classes.description}>
        <ImagineLinkify>
          {description}
        </ImagineLinkify>
      </div>
      <div className={classes.infoContainer}>
        <div className={classes.label}>{t('objetivo')}</div>
        <div className={classes.description}>
          <ImagineLinkify>
            {goal}
          </ImagineLinkify>
        </div>
      </div>
      <div className={classes.label}>{t('criterios')}</div>
      <div className={classes.description}>
        <ImagineLinkify>
          {requirement}
        </ImagineLinkify>
      </div>
    </div>
  );
}

export { ChallengeInfoDetails };